import { useEffect, useContext, useMemo } from 'react';
import { useGetContactConversationsUnreadMessagesCount, AuthenticationContext } from '@vs-online-only-app/state';

const isStandalone = window === window.top;

type UseUnreadContactMessagesNotifierParams = {
  enabled?: boolean;
};

export const useUnreadContactMessagesNotifier = ({
  enabled = true,
}: UseUnreadContactMessagesNotifierParams = {}) => {
  const {
    data: { totalCount },
  } = useGetContactConversationsUnreadMessagesCount();

  const { isAuthenticated, logoutStatus } = useContext(AuthenticationContext);

  const isEnabled = useMemo(() => enabled && !isStandalone && isAuthenticated && !['loading', 'success'].includes(logoutStatus), [enabled, isAuthenticated, logoutStatus]);

  useEffect(() => {
    if (!isEnabled) {
      return;
    }
    window.top?.postMessage(
      {
        eventName: 'unreadContactMessagesCount',
        count: totalCount,
      },
      '*',
    );
  }, [totalCount, isEnabled]);
};
